import React, { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Card, Button, Form, Row, Col } from "react-bootstrap";
import search from "../../assets/svg/search.svg";
import template from "../../assets/svg/template.svg";
import print from "../../assets/svg/print-blue.svg";
import add from "../../assets/svg/add.svg";
import customize from "../../assets/svg/customize.svg";
import "./asset.css";
import CustomSelectWithAPI from "../searchbox/searchbox-filter.js";
import close from "../../assets/svg/close.svg";
import edit from "../../assets/svg/edit.svg";
import del from "../../assets/svg/delete.svg";
import { getAssetListApi, templateDownloadApi, uploadAssetApi } from "./asset-api.js";
import columnicon from "../../assets/svg/table-column-icon.svg";
import ReactPaginate from "react-paginate";
import lar from "../../assets/svg/lar.svg";
import rar from "../../assets/svg/rar.svg";
import upload from "../../assets/svg/upload-asset.svg";
import { Toast, ToastContainer } from "react-bootstrap";
import DeleteModal from "../common/delete-modal";
import { useGlobal } from "../../GlobalContext";

const AssetListPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { assetFilters, setAssetFilters, listingColumns, setListingColumns } = useGlobal();

  useEffect(() => {
    const sessionMsg = sessionStorage.getItem("toastMessage");
    const sessionStatus = sessionStorage.getItem("toastStatus");
    if (sessionMsg) {
      setSnackbarMessage(sessionMsg);
      setSnackbarStatus(sessionStatus !== "false");
      handleSnackbarShow();
      sessionStorage.removeItem("toastMessage");
      sessionStorage.removeItem("toastStatus");
    } else if (location.state?.toastMessage) {
      setSnackbarMessage(location.state.toastMessage);
      setSnackbarStatus(location.state.toastStatus !== false);
      handleSnackbarShow();
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const handleResetFilters = () => {
    setSearchText("");
    setSortByField("");
    setSortBy("");
    setSortBySelect("");
    setManagedByOption(null);
    setAssignedToOption(null);
    setStatusOption("");
    setLocationOption(null);
    setDepartmentOption(null);
    setItemOffset(0);
    setAssetFilters({});
  };

  const [searchText, setSearchText] = useState(assetFilters.searchText || "");
  const [sortByField, setSortByField] = useState(assetFilters.sortByField || "");
  const [sortBy, setSortBy] = useState(assetFilters.sortBy || "");
  const [sortBySelect, setSortBySelect] = useState(assetFilters.sortBySelect || "");
  const [managedByOption, setManagedByOption] = useState(assetFilters.managedByOption || null);
  const [assignedToOption, setAssignedToOption] = useState(assetFilters.assignedToOption || null);
  const [statusOption, setStatusOption] = useState(assetFilters.statusOption || "");
  const [locationOption, setLocationOption] = useState(assetFilters.locationOption || null);
  const [departmentOption, setDepartmentOption] = useState(assetFilters.departmentOption || null);

  const [isManagedHovered, setManagedHovered] = useState(false);
  const [isAssignedToHovered, setAssignedToHovered] = useState(false);
  const [isStatusHovered, setStatusHovered] = useState(false);
  const [isLocationHovered, setLocationHovered] = useState(false);
  const [isDepartmentHovered, setDepartmentHovered] = useState(false);
  const [assetList, setAssetList] = useState([]);

  const [showCustomColumPopup, setShowCustomColumPopup] = useState(false);

  const [count, setCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(assetFilters.itemOffset || 0);
  const [itemsPerPage, setItemsPerPage] = useState(assetFilters.itemsPerPage || 10);
  const [pageCount, setPageCount] = useState(0);
  const [sortField, setSortField] = useState("");
  const [sortDir, setSortDir] = useState("");

  const [selectedIds, setSelectedIds] = useState([]);

  const [assetId, setAssetId] = useState(null);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [deleteId, setDeleteId] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [isOpenBulkDelete, setIsOpenBulkDelete] = useState(false);
  useEffect(() => {
    if (deleteId != null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);

  const cancelDelete = () => {
    setDeleteId(null);
    setIsOpenDelete(false);
  };
  const onSuccessDelete = (response) => {
    setDeleteId(null);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
    if (response.success === true) {
      setIsOpenDelete(false);
      getAssetList();
    }
  };

  const cancelBulkDelete = () => {
    setIsOpenBulkDelete(false);
  };
  const onSuccessBulkDelete = (response) => {
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
    if (response.success === true) {
      setSelectedIds([]);
      setIsOpenBulkDelete(false);
      getAssetList();
    }
  };

  const toggleSelect = (id) => {
    setSelectedIds((prev) => (prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]));
  };

  const toggleSelectAll = () => {
    if (selectedIds.length === assetList.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(assetList.map((row) => row.id));
    }
  };

  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
  const handleManagedByDropdownChange = (option) => {
    console.log(option);
    setManagedByOption(option);
  };
  const handleAssignedToDropdownChange = (option) => {
    console.log(option);
    setAssignedToOption(option);
  };
  const handleStatusDropdownChange = (option) => {
    console.log(option);
    setStatusOption(option);
  };
  const handleLocationDropdownChange = (option) => {
    console.log(option);
    setLocationOption(option);
  };
  const handleDepartmentDropdownChange = (option) => {
    console.log(option);
    setDepartmentOption(option);
  };

  useEffect(() => {
    setItemOffset(0);
  }, [searchText, managedByOption, assignedToOption, locationOption, departmentOption, statusOption]);

  useEffect(() => {
    getAssetList();
  }, [searchText, itemsPerPage, itemOffset, sortBySelect, managedByOption, assignedToOption, locationOption, departmentOption, statusOption]);

  useEffect(() => {
    const filters = {
      searchText,
      sortByField,
      sortBy,
      sortBySelect,
      managedByOption,
      assignedToOption,
      statusOption,
      locationOption,
      departmentOption,
      itemOffset,
      itemsPerPage,
    };
    setAssetFilters(filters);
  }, [searchText, sortByField, sortBy, sortBySelect, managedByOption, assignedToOption, statusOption, locationOption, departmentOption, itemOffset, itemsPerPage]);

  const getAssetList = async () => {
    try {
      const response = await getAssetListApi(`search=${searchText}&limit=${itemsPerPage}&skip=${itemOffset * itemsPerPage}&sort_field=${sortByField}&sort_dir=${sortBy}&managed_by=${managedByOption != null ? managedByOption.value : ""}&assigned_to=${assignedToOption != null ? assignedToOption.value : ""}&location=${locationOption != null ? locationOption.value : ""}&department=${departmentOption != null ? departmentOption.value : ""}&status=${statusOption !== "" ? statusOption : ""}`);
      if (response.data.success === true) {
        setAssetList(response.data.assets);
        setCount(response.data.total_rec);
        setPageCount(response.data.total_pgs);
        if (response.data.total_pgs > 0 && itemOffset >= response.data.total_pgs) {
          setItemOffset(0);
        }
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const handlePageClick = (event) => {
    setItemOffset(event.selected);
  };

  const isFieldEnabled = (field) => {
    return listingColumns.some((item) => item.status === true && item.label === field);
  };
  const dropdownRef = useRef(null);
  const toggleColumn = (key) => {
    const tempColumn = [...listingColumns];
    const index = tempColumn.findIndex((column) => column.value === key);
    if (index > -1) {
      tempColumn[index].status = !tempColumn[index].status;
    }
    setListingColumns(tempColumn);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowCustomColumPopup(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const fileInputRef = useRef(null);
  const handleFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    } else {
      console.error("File input is not initialized.");
    }
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    console.log(file);
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result; // this will be the byte code (base64String)
        console.log("Base64 String:", base64String.toString());
        uploadAssetExcel(base64String);
        console.log(base64String); // You can view the byte code in the console
      };
      reader.readAsDataURL(file);
    } else {
      alert("Please select a valid image file.");
    }
  };

  const uploadAssetExcel = async (base64String) => {
    const response = await uploadAssetApi({ upload_file: base64String });
    if (response?.status === 200 && response?.data?.success === true) {
      getAssetList(1);
    }
    setSnackbarMessage(response?.data?.message || (response?.data?.success ? "File uploaded successfully" : "Upload failed"));
    setSnackbarStatus(response?.data?.success || false);
    handleSnackbarShow();
  };
  const templateDownload = async () => {
    try {
      const response = await templateDownloadApi();
      const base64String = response?.data?.base64;
      if (base64String) {
        const fileName = "Asset_Upload_Template_" + new Date().getTime() + ".xlsx";
        const binary = atob(base64String);
        const array = [];
        for (let i = 0; i < binary.length; i++) {
          array.push(binary.charCodeAt(i));
        }
        const blob = new Blob([new Uint8Array(array)], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setSnackbarMessage("Template downloaded successfully");
        setSnackbarStatus(true);
        handleSnackbarShow();
      } else {
        setSnackbarMessage(response?.data?.message || "Failed to download template");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (err) {
      setSnackbarMessage(err.response?.data?.message || "Failed to download template");
      setSnackbarStatus(false);
      handleSnackbarShow();
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#FFFFFF",
        borderRadius: "12px",
        width: "100%",
        padding: "14px",
        boxSizing: "border-box",
        overflowX: "hidden",
      }}
    >
      <div className="px-2 style-justify-between">
        <div className="mt-2 ">
          <div className="asset-title">Assets</div>
          <div className="total-record">{count} records</div>
        </div>
        <div className="style-justify-start" style={{ flexWrap: "wrap" }}>
          <div className="mt-2 search-box flex items-center border rounded-md w-full md:w-auto">
            <span className="icon mr-2">
              <img src={search} alt="search" className="search-icon w-4 h-4" />
            </span>
            <input type="text" placeholder="Search" className="outline-none w-full" value={searchText} onChange={(e) => setSearchText(e.target.value)} />
          </div>
          <Button
            className="mt-2 add-asset-btn ms-2"
            onClick={() => {
              navigate("/asset/create");
            }}
          >
            <img src={add} alt="Template" style={{ width: 16, height: 16, marginRight: 6 }} />
            Create asset
          </Button>
          <Button
            onClick={() => {
              templateDownload();
            }}
            className="mt-2 ms-2 border-btn "
          >
            <img src={template} alt="Template" style={{ width: 16, height: 16, marginRight: 6 }} />
            Template
          </Button>
          <Button
            onClick={() => {
              handleFileClick();
            }}
            className="mt-2 ms-2 border-btn"
          >
            <img src={upload} alt="print" style={{ width: 16, height: 16, marginRight: 6 }} />
            Upload
          </Button>
          {selectedIds.length > 0 && (
            <Button
              onClick={() => {
                setIsOpenBulkDelete(true);
              }}
              className="mt-2 ms-2"
              style={{
                backgroundColor: "#FF4444",
                color: "#ffffff",
                border: "none",
                borderRadius: "8px",
                padding: "8px 16px",
                fontWeight: "500",
              }}
            >
              <img src={del} alt="delete" style={{ width: 16, height: 16, marginRight: 6, filter: "brightness(0) invert(1)" }} />
              Delete ({selectedIds.length})
            </Button>
          )}
          <input
            ref={fileInputRef}
            type="file"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            onChange={handleFileChange}
            style={{ display: "none" }} // Hide the actual file input
          />
        </div>
      </div>
      <div className="px-2 style-justify-between">
        <div className="style-justify-start" style={{ flexWrap: "wrap" }}>
          <div className="mt-2 filter-txt">Filter :</div>
          <div className="mt-2">
            <select
              className="ps-2 filter-drop-down filter-custom-select"
              id="perpage"
              value={sortBySelect}
              onChange={(event) => {
                setSortBySelect(event.target.value);
                const [field, order] = event.target.value.split(" ");
                setSortByField(field);
                setSortBy(order);
              }}
            >
              <option value="">Sort by (Date created)</option>
              <option value="name asc">Name (Asc)</option>
              <option value="name desc">Name (Dsc)</option>
              <option value="created asc">Create Date (Oldest)</option>
              <option value="created desc">Created Date (Newest)</option>
              <option value="updated asc">Updated Date (Oldest)</option>
              <option value="updated desc">Updated Date (Newest)</option>
            </select>
          </div>
          <div className={`mt-2 style-justify-center ${isManagedHovered === true ? "filter-select-hover" : ""}`} style={{ maxWidth: "160px" }} onMouseEnter={() => setManagedHovered(true)} onMouseLeave={() => setManagedHovered(false)}>
            <div style={{ maxWidth: "148px" }}>
              <CustomSelectWithAPI onDropdownChange={handleManagedByDropdownChange} apiUrl={adminApiUrl + "get_employee"} params={{}} placeholder={"Managed by"} selectedOption={managedByOption} />
            </div>
            {isManagedHovered === true && managedByOption != null && (
              <img
                src={close}
                alt="close"
                style={{ marginRight: 6 }}
                onClick={() => {
                  setManagedByOption(null);
                }}
              />
            )}
          </div>
          <div className={`mt-2 style-justify-center ${isAssignedToHovered === true ? "filter-select-hover" : ""}`} style={{ maxWidth: "160px" }} onMouseEnter={() => setAssignedToHovered(true)} onMouseLeave={() => setAssignedToHovered(false)}>
            <div style={{ maxWidth: "148px" }}>
              <CustomSelectWithAPI onDropdownChange={handleAssignedToDropdownChange} apiUrl={adminApiUrl + "get_employee"} params={{}} placeholder={"Assigned To"} selectedOption={assignedToOption} />
            </div>
            {isAssignedToHovered === true && assignedToOption != null && (
              <img
                src={close}
                alt="close"
                style={{ marginRight: 6 }}
                onClick={() => {
                  setAssignedToOption(null);
                }}
              />
            )}
          </div>
          <div className={`mt-2 style-justify-center ${isStatusHovered === true ? "filter-select-hover" : ""}`} style={{ minWidth: "fit-content", maxWidth: "185px" }} onMouseEnter={() => setStatusHovered(true)} onMouseLeave={() => setStatusHovered(false)}>
            <div style={{ minWidth: "fit-content" }}>
              {/*  <CustomSelectWithAPI onDropdownChange={handleStatusDropdownChange} apiUrl={adminApiUrl + "get_location"} params={{}} placeholder={"Status"} selectedOption={statusOption} /> */}
              <select
                className="ps-2 filter-drop-down filter-custom-select"
                style={{ minWidth: statusOption === "Non-Allocated" ? "145px" : "auto" }}
                value={statusOption}
                onChange={(event) => {
                  setStatusOption(event.target.value);
                }}
              >
                <option value="">Status</option>
                <option value="Allocated">Allocated</option>
                <option value="Non-Allocated">Non-Allocated</option>
                <option value="Missing">Missing</option>
                <option value="Repair">Repair</option>
                <option value="Scrap">Scrap</option>
              </select>
            </div>
            {isStatusHovered === true && statusOption !== "" && (
              <img
                src={close}
                alt="close"
                style={{ marginRight: "6px" }}
                onClick={() => {
                  setStatusOption("");
                }}
              />
            )}
          </div>
          <div className={`mt-2 style-justify-center ${isLocationHovered === true ? "filter-select-hover" : ""}`} style={{ maxWidth: "160px" }} onMouseEnter={() => setLocationHovered(true)} onMouseLeave={() => setLocationHovered(false)}>
            <div style={{ maxWidth: "140px" }}>
              <CustomSelectWithAPI onDropdownChange={handleLocationDropdownChange} apiUrl={adminApiUrl + "get_location"} params={{}} placeholder={"Location"} selectedOption={locationOption} />
            </div>
            {isLocationHovered === true && locationOption != null && (
              <img
                src={close}
                alt="close"
                style={{ marginRight: "6px" }}
                onClick={() => {
                  setLocationOption(null);
                }}
              />
            )}
          </div>

          <div className={`mt-2 style-justify-center ${isDepartmentHovered === true ? "filter-select-hover" : ""}`} style={{ maxWidth: "160px" }} onMouseEnter={() => setDepartmentHovered(true)} onMouseLeave={() => setDepartmentHovered(false)}>
            <div style={{ maxWidth: "140px" }}>
              <CustomSelectWithAPI onDropdownChange={handleDepartmentDropdownChange} apiUrl={adminApiUrl + "get_department"} params={{}} placeholder={"Department"} selectedOption={departmentOption} />
            </div>
            {isDepartmentHovered === true && departmentOption != null && (
              <img
                src={close}
                alt="close"
                style={{ marginRight: "6px" }}
                onClick={() => {
                  setDepartmentOption(null);
                }}
              />
            )}
          </div>
        </div>
        <div className="d-flex align-items-center mt-2 flex-shrink-0">
          {(Boolean(searchText || sortBySelect || managedByOption || assignedToOption || statusOption || locationOption || departmentOption)) && (
            <button
              type="button"
              className="reset-filter-btn me-2"
              onClick={handleResetFilters}
              title="Reset all filters"
            >
              Reset filters
            </button>
          )}
          <Button
            className="customize-btn ms-1"
            onClick={() => {
              setShowCustomColumPopup(true);
            }}
          >
            <img src={customize} alt="customize" style={{ width: 16, height: 16, marginRight: 6 }} />
            Customize table
          </Button>
        </div>
      </div>

      <div className="mx-2 mt-2 table-container table-responsive">
        <table className="dock-table">
          <thead>
            <tr>
              <th style={{ width: "76px" }}>
                <input type="checkbox" checked={selectedIds.length === assetList?.length} onChange={toggleSelectAll} />
              </th>
              {isFieldEnabled("S.No") && (
                <th style={{ width: "96px" }}>
                  <div className="style-justify-between">
                    <div>S.No</div>
                    {/* <img src={columnicon} alt="columnicon" /> */}
                  </div>
                </th>
              )}
              {isFieldEnabled("Tag") && (
                <th style={{ width: "206px" }}>
                  <div className="style-justify-between">
                    <div>Tag</div>
                    <img src={columnicon} alt="columnicon" />
                  </div>
                </th>
              )}
              {isFieldEnabled("Code") && (
                <th style={{ width: "206px" }}>
                  <div className="style-justify-between">
                    <div>Code</div>
                    <img src={columnicon} alt="columnicon" />
                  </div>
                </th>
              )}
              {isFieldEnabled("Name") && (
                <th style={{ width: "206px" }}>
                  <div className="style-justify-between">
                    <div>Name</div>
                    <img src={columnicon} alt="columnicon" />
                  </div>
                </th>
              )}
              {isFieldEnabled("Type") && (
                <th style={{ width: "206px" }}>
                  <div className="style-justify-between">
                    <div>Type</div>
                    <img src={columnicon} alt="columnicon" />
                  </div>
                </th>
              )}
              {isFieldEnabled("Serial No") && (
                <th style={{ width: "206px" }}>
                  <div className="style-justify-between">
                    <div>Serial No</div>
                    <img src={columnicon} alt="columnicon" />
                  </div>
                </th>
              )}
              {isFieldEnabled("Invoice no") && (
                <th style={{ width: "206px" }}>
                  <div className="style-justify-between">
                    <div>Invoice no</div>
                    <img src={columnicon} alt="columnicon" />
                  </div>
                </th>
              )}
              {isFieldEnabled("Location") && (
                <th style={{ width: "206px" }}>
                  <div className="style-justify-between">
                    <div>Location</div>
                    <img src={columnicon} alt="columnicon" />
                  </div>
                </th>
              )}
              {isFieldEnabled("Assigned To") && (
                <th style={{ width: "206px" }}>
                  <div className="style-justify-between">
                    <div>Assigned To</div>
                    <img src={columnicon} alt="columnicon" />
                  </div>
                </th>
              )}
              {isFieldEnabled("Managed By") && (
                <th style={{ width: "206px" }}>
                  <div className="style-justify-between">
                    <div>Managed By</div>
                    <img src={columnicon} alt="columnicon" />
                  </div>
                </th>
              )}
              {isFieldEnabled("Status") && (
                <th style={{ width: "206px" }}>
                  <div className="style-justify-between">
                    <div>Status</div>
                    <img src={columnicon} alt="columnicon" />
                  </div>
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {assetList?.map((device, i) => (
              <tr
                key={i}
                onClick={() => {
                  navigate("/asset/view", {
                    state: { id: device.id },
                  }); /* setDockMasterId(device.id); setViewModal(true); */
                }}
              >
                <td>
                  <input
                    type="checkbox"
                    checked={selectedIds.includes(device.id)}
                    onClick={(event) => {
                      event.stopPropagation();
                    }}
                    onChange={(event) => {
                      event.stopPropagation();
                      toggleSelect(device.id);
                    }}
                  />
                </td>
                {isFieldEnabled("S.No") && <td>{itemOffset * itemsPerPage + (i + 1)}</td>}
                {isFieldEnabled("Tag") && <td className="truncate-cell">{device.asset_tag || "--"}</td>}
                {isFieldEnabled("Code") && <td className="truncate-cell">{device.code || "--"}</td>}
                {isFieldEnabled("Name") && <td className="truncate-cell">{device.name || "--"}</td>}
                {isFieldEnabled("Type") && <td className="truncate-cell">{device.asset_type || "--"}</td>}
                {isFieldEnabled("Serial No") && <td className="truncate-cell">{device.serial_number || "--"}</td>}
                {isFieldEnabled("Invoice no") && <td className="truncate-cell">{device.invoice_number || "--"}</td>}
                {isFieldEnabled("Location") && <td className="truncate-cell">{device.location || "--"}</td>}
                {isFieldEnabled("Assigned To") && <td className="truncate-cell">{device.assignee || "--"}</td>}
                {isFieldEnabled("Managed By") && <td className="truncate-cell">{device.managed_by || "--"}</td>}
                {isFieldEnabled("Status") && (
                  <td className="truncate-cell hover-time-cell group">
                    <span className="time-value">{device.asset_status || "--"}</span>
                    <div className="time-actions">
                      <button
                        onClick={(event) => {
                          event.stopPropagation();
                          navigate(`/asset/edit/${device.id}`, {
                            state: { id: device.id },
                          });
                          /*  setAssetId(device.id); */
                        }}
                        className="icon-btn edit-btn"
                        title="Edit"
                      >
                        <img src={edit} alt="Edit" className="icon-img" />
                      </button>
                      <button
                        onClick={(event) => {
                          event.stopPropagation();
                          setDeleteId(device.id);
                        }}
                        className="icon-btn delete-btn"
                        title="Delete"
                      >
                        <img src={del} alt="Delete" className="icon-img" />
                      </button>
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Row style={{ marginTop: "16px" }}>
        <Col>
          <div className="d-flex align-items-center justify-content-start mx-3">
            <span
              style={{
                fontSize: "13px",
                fontWeight: "500",
                color: "#172B4D",
              }}
            >
              Records per page :
            </span>
            <select
              className="select3 ms-2"
              id="perpage"
              value={itemsPerPage}
              onChange={(event) => {
                setItemsPerPage(event.target.value);
              }}
              style={{
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "700",
                lineHeight: "18.9px",
                color: "#212129",
                width: "56px",
                height: "24px",
                borderRadius: "6px",
                border: "1px solid #E5E5E5",
                padding: "0 4px",
                backgroundColor: "#FFFFFF",
              }}
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="30">30</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </Col>
        <Col>
          <div className="d-flex justify-content-end">
            <ReactPaginate forcePage={itemOffset} previousLabel={<img src={lar} className="ar3" alt="previous" />} nextLabel={<img src={rar} className="ar3" alt="next" />} breakLabel={"..."} pageCount={Math.max(1, pageCount || 0)} marginPagesDisplayed={2} pageRangeDisplayed={3} onPageChange={handlePageClick} containerClassName={"pagination"} activeClassName={"active"} />
          </div>
        </Col>
      </Row>
      {showCustomColumPopup && (
        <div
          ref={dropdownRef}
          style={{
            position: "absolute",
            top: "40px",
            right: "-5%",
            transform: "translateX(-50%)",
            backgroundColor: "#ffffff",
            color: "#1E1E1E",
            padding: "16px",
            borderRadius: "16px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,
            alignItems: "end",
          }}
        >
          <div className="font-semibold mb-2" style={{ fontSize: "18px" }}>
            Select Columns
          </div>
          {listingColumns.map((col, index) => (
            <div key={col.value} className="mb-1">
              <label>
                <input type="checkbox" checked={col.status} onChange={() => toggleColumn(col.value)} />
                <span className="ms-2" style={{ fontSize: "16px" }}>
                  {col.label}
                </span>
              </label>
            </div>
          ))}
        </div>
      )}
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>

      {/* Delete Modal - Single Delete */}
      {isOpenDelete && <DeleteModal deleteUrl={`asset/delete/${deleteId}`} ids={null} onSuccess={onSuccessDelete} onCancel={cancelDelete} />}

      {/* Delete Modal - Bulk Delete */}
      {isOpenBulkDelete && <DeleteModal deleteUrl="asset/bulk_delete" ids={selectedIds} onSuccess={onSuccessBulkDelete} onCancel={cancelBulkDelete} />}
    </div>
  );
};
export default AssetListPage;
